export const pushCampaignName = (name: string): void => {
  window?.dataLayer?.push({ 'campaign_name': name });
};
